if (!customElements.get("m-slideshow")) {
  class MSlideshow extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed);
      this.showArrows = this.dataset.enableArrows === "true";
      this.showDots = this.dataset.enableDots === "true";
      this.adaptHeight = this.dataset.slideHeight === "adapt";
      this.id = this.dataset.id;
      this.sliderContainer = this.querySelector(".swiper-container");

      this.lastVideo = null;
      this.lastActive = null;
      this.timeout = null;
      this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
      this.initSlider();
      this.watchBackgroundVideos();
    }

    disconnectedCallback() {
      this.mediaListeners && this.mediaListeners.abort();
    }

    // Vídeo de fundo do slide de imagem: cada <video data-src> diz em data-media a tela
    // em que aparece. Só o do slide ativo e da tela atual baixa e toca. Com "reduzir
    // movimento" ligado ou autoplay barrado (modo economia do iPhone), fica a capa.
    syncBackgroundVideos(swiper) {
      const activeSlide = swiper && swiper.slides[swiper.activeIndex];

      this.querySelectorAll("video[data-src]").forEach((video) => {
        const shouldPlay =
          !this.reducedMotion.matches &&
          activeSlide &&
          activeSlide.contains(video) &&
          window.matchMedia(video.dataset.media).matches;

        if (!shouldPlay) {
          video.pause();
          return;
        }

        if (!video.getAttribute("src")) {
          // O video so comeca a baixar depois do load: ate la fica a capa (a
          // imagem do slide, que e o LCP da Home) sem disputar banda com ele.
          if (document.readyState !== "complete") {
            if (!this.esperandoLoad) {
              this.esperandoLoad = true;
              window.addEventListener("load", () => this.syncBackgroundVideos(this.slider), { once: true });
            }
            return;
          }
          video.addEventListener("playing", () => video.classList.add("is-playing"), { once: true });
          video.src = video.dataset.src;
        }

        const playPromise = video.play();
        if (playPromise !== undefined) playPromise.catch(() => {});
      });
    }

    watchBackgroundVideos() {
      const videos = this.querySelectorAll("video[data-src]");
      if (!videos.length) return;

      this.mediaListeners = new AbortController();
      const queries = new Set([...videos].map((video) => video.dataset.media));
      const mediaQueries = [this.reducedMotion, ...[...queries].map((query) => window.matchMedia(query))];

      mediaQueries.forEach((mediaQuery) => {
        mediaQuery.addEventListener("change", () => this.syncBackgroundVideos(this.slider), {
          signal: this.mediaListeners.signal,
        });
      });
    }

    initSlider() {
      this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
        init: false,
        autoplay: this.autoplay
          ? {
              delay: this.autoplaySpeed * 1000,
              disableOnInteraction: true,
            }
          : false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        speed: 1000,
        navigation: this.showArrows
          ? {
              nextEl: this.querySelector(".m-slider-controls__button-next"),
              prevEl: this.querySelector(".m-slider-controls__button-prev"),
            }
          : false,
        pagination: this.showDots
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
              bulletClass: "m-dot",
              bulletActiveClass: "m-dot--active",
            }
          : false,
        breakpoints: {
          992: {
            threshold: 2,
          },
        },
        on: {
          init() {
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 100);
          },
        },
      });

      this.lastSlide = null;
      this.currentSlide = null;
      this.slider && this.slider.on("init", this.handleChange.bind(this));
      this.slider && this.slider.on("slideChange", this.handleChange.bind(this));
      this.slider.init();

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
      }
    }

    handleChange(swiper) {
      const { activeIndex, slides } = swiper;
      const slideType = slides[activeIndex] && slides[activeIndex].dataset.slideType;
      this.lastActive && this.slider.slideToLoop(this.lastActive);
      if (slideType === "video_slide") {
        const video = slides[activeIndex] && slides[activeIndex].querySelector("video");

        if (video) {
          let playPromise = video.play();
          this.lastVideo && this.lastVideo.pause();
          if (playPromise !== undefined) {
            playPromise.then(() => {
              this.lastVideo = video;
            });
          }
        }
      } else {
        this.lastVideo && this.lastVideo.pause();
        this.lastVideo = null;
      }
      this.syncBackgroundVideos(swiper);
    }

    onBlockSelect(ev) {
      const block = ev.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-slideshow", MSlideshow);
}
